export const EXPERIAN_DISPLAY_TYPE = {
  SCREEN: "SCREEN", // full-page MaintenancePage
  BANNER: "BANNER", // inline ExperianBanner on form steps
};
